import React from 'react'
import { connect } from 'react-redux'
import { CloseOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import utils from 'utils'

export const NavSearch = (props) => {
  const { active, close, headerNavColor } = props
  const mode = utils.getColorContrast(headerNavColor)

  return (
    <div
      className={`nav-search ${active ? 'nav-search-active' : ''} ${mode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className="d-flex align-items-center w-100">
        {/* <SearchInput close={close} active={active}/> */}
      </div>
      <div className="nav-close" onClick={close}>
        <CloseOutlined />
      </div>
    </div>
  )
}

const mapStateToProps = ({ theme }) => {
  const { headerNavColor } = theme
  return { headerNavColor }
}

NavSearch.propTypes = {
  active: PropTypes.bool,
  close: PropTypes.func,
  headerNavColor: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, {})(NavSearch)
